// extracted by css-extract-rspack-plugin
export default {"billingTermsCard":"qNXbN1uAgN8DDuqV","addTerm":"XVZoBmd_78aWtVKa","dateInput":"BPJWauwTZk4O31Ad","quantityInput":"ppUZCoGRwce9RQo2"};